/**
 * Link type canonicalization (frontend mirror of backend/utils/link_type.py).
 *
 * Why: historically `link_type` could be `'follow'`, `'do-follow'`, `'dofollow'`,
 * `'no-follow'`, `'nofollow'`, `'sponsored'`, `'ugc'`. Centralize so display +
 * comparison logic doesn't drift between Checkout, MyOrders, Admin CRM, etc.
 */

export const LINK_TYPE_VALUES = ['dofollow', 'nofollow', 'sponsored', 'ugc'];

const _LABELS = {
  dofollow: 'DoFollow',
  nofollow: 'NoFollow',
  sponsored: 'Sponsored',
  ugc: 'UGC',
};

/** Return canonical value or '' if unknown. */
export function canonicalLinkType(value) {
  if (!value) return '';
  const v = String(value).trim().toLowerCase().replace(/_/g, '-');
  if (v === 'dofollow' || v === 'do-follow' || v === 'follow') return 'dofollow';
  if (v === 'nofollow' || v === 'no-follow') return 'nofollow';
  if (v === 'sponsored') return 'sponsored';
  if (v === 'ugc') return 'ugc';
  return '';
}

/** Human-readable label (or '' if unknown). */
export function linkTypeLabel(value) {
  return _LABELS[canonicalLinkType(value)] || '';
}

/** Convenience helper for visual styling. */
export function isDofollow(value) {
  return canonicalLinkType(value) === 'dofollow';
}
